import React from 'react'
import {
    Form,
    Input,
    InputNumber,
    Button,
    Tabs,
    Radio,
    Select,
    Card,
    DatePicker,
    Upload,
    notification,
    message,
    Row,
    Col,
    Modal,
    Divider,
    Typography,
    Table,
    Space,
    Tag,
    Tooltip,
    Image,
    Alert,
    Collapse,
    Checkbox,
    Popover,
} from 'antd';
import {
    LoadingOutlined,
    PlusOutlined,
    UploadOutlined,
    ExclamationCircleOutlined,
    SearchOutlined,
    CheckCircleFilled,
    InfoCircleOutlined,
    ClockCircleOutlined,
    CloseOutlined,
    UpOutlined,
    DownOutlined,
    AlertFilled,
    WarningFilled,
    ArrowDownOutlined,
    ArrowUpOutlined,
} from '@ant-design/icons';
import { useContext, useEffect, useState } from 'react';
import moment from "moment";

const { TabPane } = Tabs;
const { TextArea } = Input;
const { Option } = Select;
const { confirm } = Modal;
const { Panel } = Collapse;
const { Text, Link, Title } = Typography;


const AddEpisode = (props, form) => {
    const episodesForm = Form.useForm();

    const episodesSortingButtons = () => {
        return (
            <>
                <Button style={{ marginRight: '10px' }}>
                    <ArrowDownOutlined />
                </Button>
                <Button>
                    <ArrowUpOutlined />
                </Button>
            </>
        );
    };
    // console.log(typeof (props.name))
    let str = props.name
    const key_value = '1'
    if (str !== undefined) {
        const key_value = str.charAt(str.length - 1)
    }
    console.log(props)

    return (
        <Collapse>
            <Panel
                header={props.name}
                key={key_value}
                extra={episodesSortingButtons()}
            >
                <Row gutter={30}>
                    <Col span={17}>
                        <Form.Item name='ep_title' label="Title">
                            <Input
                                placeholder="Enter title here..."
                                extra="English"
                            />
                        </Form.Item>
                    </Col>
                    <Col span={7}>
                        <Form.Item name={'ep_releaseDate'} label="Original release date">
                            <DatePicker style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col span={17}></Col>
                    <Col span={7}>
                        <Row>
                            <Col span={24}>
                                Key art (4:3) (Optional){' '}
                                <Tooltip title="Some description text runs here like this">
                                    <span style={{ fontSize: '15px' }}>
                                        <InfoCircleOutlined
                                            size="small"
                                            color="rgba(0, 0, 0, 0.45)"
                                        />
                                    </span>
                                </Tooltip>
                            </Col>
                            <Col span={24}>
                                <Button>Browse...</Button>{' '}
                                <Button>Google Drive</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item name='ep_description'
                            label="Synopsis" required>
                            <TextArea
                                placeholder="Enter title here..."
                                tooltip="Some information about this title displays here"
                                extra="English"
                                showCount
                                maxLength={400}
                                rows="4"
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={30}>
                    <Col span={24}>
                        <Title level={4}>
                            Video and Audio Files{' '}
                            <Tooltip title="Some description text runs here like this">
                                <span style={{ fontSize: '15px' }}>
                                    <InfoCircleOutlined
                                        size="small"
                                        color="rgba(0, 0, 0, 0.45)"
                                    />
                                </span>
                            </Tooltip>
                        </Title>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Row gutter={30}>
                            <Col span={6}>Mezzanine</Col>
                            <Col span={6}>Raja_Rani_Movie.mp4</Col>
                            <Col span={6}>
                                <Select
                                    style={{ width: '100%' }}
                                    defaultValue="telugu"
                                    options={[
                                        {
                                            value: 'telugu',
                                            label: 'Telugu (India)',
                                        },
                                        {
                                            value: 'hindi',
                                            label: 'Hindi (India)',
                                        },
                                        {
                                            value: 'spanish',
                                            label: 'Spanish (Spain)',
                                        },
                                    ]}
                                />
                            </Col>
                            <Col span={6}>
                                <Button style={{ marginRight: '10px' }}>
                                    Browse...
                                </Button>
                                <Button>Google Drive</Button>
                            </Col>
                        </Row>
                        <Row
                            gutter={30}
                            style={{ marginTop: '20px' }}
                        >
                            <Col span={6}>Trailer (optional)</Col>
                            <Col span={6}></Col>
                            <Col span={6}>
                                <Select
                                    style={{ width: '100%' }}
                                    defaultValue="telugu"
                                    disabled
                                    options={[
                                        {
                                            value: 'telugu',
                                            label: 'Telugu (India)',
                                        },
                                        {
                                            value: 'hindi',
                                            label: 'Hindi (India)',
                                        },
                                        {
                                            value: 'spanish',
                                            label: 'Spanish (Spain)',
                                        },
                                    ]}
                                />
                            </Col>
                            <Col span={6}>
                                <Button style={{ marginRight: '10px' }}>
                                    Browse...
                                </Button>
                                <Button>Google Drive</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Divider style={{ margin: '10px 0' }} />
                    </Col>
                    <Col span={24}>
                        <Button>Add audio file</Button>
                    </Col>
                </Row>

                <Row gutter={30} style={{ marginTop: '30px' }}>
                    <Col span={24}>
                        <Title level={4}>
                            Timed Text{' '}
                            <Tooltip title="Some description text runs here like this">
                                <span style={{ fontSize: '15px' }}>
                                    <InfoCircleOutlined
                                        size="small"
                                        color="rgba(0, 0, 0, 0.45)"
                                    />
                                </span>
                            </Tooltip>
                        </Title>
                    </Col>
                    <Col span={24}>
                        <Text
                            type="warning"
                            style={{ marginRight: '10px' }}
                        >
                            <span>
                                <WarningFilled />
                            </span>{' '}
                            Missing English
                        </Text>
                        <Text
                            type="warning"
                            style={{ marginRight: '10px' }}
                        >
                            <span>
                                <WarningFilled />
                            </span>{' '}
                            Missing English
                        </Text>
                    </Col>
                    <Divider style={{ margin: '7px 0' }} />
                    <Col span={24}>
                        No Timed text files have been added
                    </Col>
                    <Divider style={{ margin: '7px 0' }} />
                    <Col span={24}>
                        <Button>Add timed text</Button>
                    </Col>
                </Row>

                <Divider />

                <Row justify="end">
                    <Col span={24}>
                        <Checkbox>Delete this episode</Checkbox>
                    </Col>
                </Row>
            </Panel>
        </Collapse>
    )
}

export default AddEpisode;